import React, { useState } from "react";
import "./Faq.css";
import Faq_banner from "./faq_banner/Faq_banner";
import Faq_have_question from "./faq_have_question/Faq_have_question";
import Faq_categories from "./faq_categories/Faq_categories";
import Faq_list from "./faq_list/Faq_list";

function Faq() {
  const [singleData, setSingleData] = useState({});
  return (
    <>
      <div className="Faq">
        <Faq_banner />
        <Faq_have_question />
        <Faq_categories singleData={singleData} setSingleData={setSingleData} />
        <Faq_list singleData={singleData} />
      </div>
    </>
  );
}

export default Faq;
